/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_ClearedInputs */

const vi_online_price_cleared = /** @type {(inputs: Online_Price_ClearedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã bỏ giá Online, website bán theo giá ERP`)
};

/**

* @param {Online_Price_ClearedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_cleared = /** @type {((inputs?: Online_Price_ClearedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_ClearedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_cleared(inputs)
});